module.exports = __webpack_public_path__ + "static/media/sai.380094fa.svg";